import { offlineStore, offlineSupported } from './offline-store';

/* Konto des Offline-Speichers - ohne Abhaengigkeit von der Anmeldung, damit auth.tsx es beim Abmelden nutzen kann. */

const ACTIVE_USER = 'activeUser';
/** Schon gemerkt (je Seitenaufruf) - die Oberfläche ruft das bei jedem Seitenwechsel auf. */
let remembered: string | null = null;
/**
 * Zaehlt jedes Abmelden. Ein Speichervorgang, der vorher begonnen hat (etwa der automatische Abgleich),
 * darf danach nichts mehr schreiben - sonst laege nach dem Abmelden wieder eine Einheit auf dem Geraet.
 */
let generation = 0;

export function offlineGeneration(): number {
  return generation;
}

/** Ein Speichervorgang wurde abgebrochen, weil das Konto inzwischen abgemeldet wurde. */
export class OfflineDataWipedError extends Error {
  constructor() {
    super('Abgemeldet - nichts gespeichert');
    this.name = 'OfflineDataWipedError';
  }
}

/**
 * Merkt sich das angemeldete Konto, damit die gespeicherten Einheiten auch ohne Netz
 * (und damit ohne Abfrage der Sitzung) dem richtigen Konto zugeordnet werden. Daten
 * anderer Konten auf diesem Gerät werden dabei entfernt.
 */
export async function rememberActiveUser(userId: string): Promise<void> {
  if (!offlineSupported() || remembered === userId) return;
  const store = offlineStore();
  await store.clearOthers(userId);
  await store.setMeta(ACTIVE_USER, userId);
  remembered = userId;
}

export async function storedActiveUser(): Promise<string | null> {
  if (!offlineSupported()) return null;
  return (await offlineStore().getMeta(ACTIVE_USER)) ?? null;
}

/** Abmelden: alles, was dieses Konto offline gespeichert hat, von diesem Gerät löschen. */
export async function wipeOfflineData(userId?: string | null): Promise<void> {
  // Zuerst, vor jedem await: laufende Speichervorgaenge sehen sofort, dass sie nichts mehr schreiben duerfen.
  generation += 1;
  if (!offlineSupported()) return;
  const store = offlineStore();
  const id = userId ?? (await store.getMeta(ACTIVE_USER));
  if (id) await store.clearUser(id);
  // Auf einem gemeinsam genutzten Geraet bleibt auch von anderen Konten nichts zurueck.
  await store.clearAll();
  await store.deleteMeta(ACTIVE_USER);
  remembered = null;
}


/** Nur fuer Tests. */
export function resetRemembered(): void {
  remembered = null;
}
